import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { patchPricingTableItem } from '../../state/pricing/actions';
import { getPricingTableId, getPricingTableItem } from '../../state/pricing/selectors';
import { PRICING_STRATEGY, PRODUCT_TYPE } from "../../state/product/Types";
import MoneyInputForm from '../form/moneyinput.component.jsx';
import Icon from "../icon/icon.component.jsx";
import LabelAmountPerUnitOfMeasure from '../unit-of-measure/perunit.component.jsx';
import ItemPriceWrapperWarning from './component/ItemPriceWrapperWarning';
import { getCostOfProductByInventoryLocation } from "../../utils/inventory/utils"
import { INVENTORY_STOCK_DIRECTION } from "../../utils/inventory/constants"


class QuoteItemUnitPrice extends Component {
    constructor(props, context) {
        super(props, context)
        let unitPrice = ''
        let calculatedPrice = ''
        let unitCost = ''
        const item = this.props.item
        const pricingStategy = item && item.attributes.itemObject ? item.attributes.itemObject.attributes.pricingStrategy : ""
        const stockDocument= this.props.stockDocument || null
        if (item) {
            unitPrice = !item.attributes.isTaxInclusive ? item.attributes.unitPrice : item.attributes.unitPriceInclusive
            calculatedPrice = item.attributes.calculatedUnitPrice
            if(stockDocument){                
                unitCost = item.attributes.unitCost
                if (stockDocument.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.IN 
                    && stockDocument.references?.length > 0 && stockDocument.references.find(r => r.attributes.referenceKey == "orders")
                ) {
                    unitPrice = unitCost
                }
            }
        }
        this.state = {
            item: item || null,
            type: this.props.type || 'quote',
            editable: this.props.editable || false,
            editMode: false,
            calculatedPrice,
            pricingStrategy: pricingStategy,
            isBeingEdited: false,
            hideEditButtons: this.props.hideEditButtons || false,
            unitPrice,
            isTaxInclusive: item ? item.attributes.isTaxInclusive : false,
            onChange: this.props.onChange || function () { },
            stockDocument,
            unitCost,
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.save = this.save.bind(this)
        this.getPrice = this.getPrice.bind(this)
        this.changePrice = this.changePrice.bind(this)
        this.priceWasModified = this.priceWasModified.bind(this)
        this.hasDiscount = this.hasDiscount.bind(this)
    }

    componentWillReceiveProps ( nextProps ) {  
        if (this.state.isBeingEdited && this.state.item.attributes.unitPrice === nextProps.item.attributes.unitPrice) {
            return
        }
        let unitCost = this.state.unitCost
        let unitPrice = this.state.unitPrice
        let calculatedPrice = this.state.calculatedPrice
        let isTaxInclusive = this.state.isTaxInclusive
        if (nextProps.item) {
            if (!this.state.stockDocument) {
                unitPrice = !nextProps.item.attributes.isTaxInclusive ? nextProps.item.attributes.unitPrice : nextProps.item.attributes.unitPriceInclusive
            }
            isTaxInclusive = nextProps.item.attributes.isTaxInclusive
            calculatedPrice = nextProps.item.attributes.calculatedUnitPrice
            if(this.state.stockDocument){
                unitCost = nextProps.item.attributes.unitCost
            }
        }

        this.setState( {
            stockDocument:nextProps.stockDocument,
            item: nextProps.item,
            unitCost: unitCost,
            unitPrice: unitPrice,
            calculatedPrice: calculatedPrice,
            isTaxInclusive: isTaxInclusive,
            type: nextProps.type || 'quote',
            editable: nextProps.editable
        })
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event?.preventDefault()
        let payload = {}
        
        payload = { mainObjectId: this.props.mainObjectId, unitPrice: this.state.unitPrice }
        if (Number(this.state.unitPrice) == Number(this.state.calculatedPrice) && Number(this.state.unitPrice) == 0) {
            payload["manualSubtotalAmount"] = this.state.unitPrice
        }
        
        
        if ( this.state.stockDocument ) {
            payload.mainObjectId = this.state.mainObjectId
        } 
        this.props.dispatch(patchPricingTableItem(this.props.itemId, this.props.mainObjectId, this.props.type, payload, true, true))
        this.triggerEdit(event)
        
    }

    handleFocus(event) {
        event.target.select()
    }

    changePrice(newValue, isBeingEdited) {
        let previousUnitPrice = this.state.unitPrice
        const cleanedValue = newValue.replace(/[^0-9\.]/g, '');
        if (!this.isInputValid(cleanedValue)) {
            return
        }
        const formattedValue = this.formatNumberAsCurrency(cleanedValue)
        this.setState({
            unitPrice : formattedValue,
            isBeingEdited: isBeingEdited,
            calculatedPrice: formattedValue,
        }, () => {
            if (this.state.hideEditButtons && Number(previousUnitPrice) != Number(newValue)) {
                this.save()
            }
        })
    }

    isInputValid(input) {
        return input !== '' && !Number.isNaN(Number(input));    
    }

    formatNumberAsCurrency(newValue) {
       
        const currencyFractionDigits = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.state.item.attributes.currency,
        }).resolvedOptions().maximumFractionDigits;

        return parseFloat(newValue).toLocaleString('en-US', {
            minimumFractionDigits : currencyFractionDigits,
            maximumFractionDigits : currencyFractionDigits,
            useGrouping: false
        });
    }

    priceWasModified() {
        let isMultiplier = PRICING_STRATEGY.MULTIPLIER == this.state.pricingStrategy
        let unitPriceEqualFromCalculated = Number(this.state.calculatedPrice) != 0 &&
            Number(this.state.calculatedPrice) == Number(this.state.unitPrice)
        let isQuickProduct = this.state.item.attributes.itemObject.type === PRODUCT_TYPE.QUICK_PRODUCTS
        let isPurchaseOrder = this.state.stockDocument && this.state.stockDocument.definition.attributes.direction === INVENTORY_STOCK_DIRECTION.IN
        return (!isMultiplier || !unitPriceEqualFromCalculated) && !isQuickProduct && !isPurchaseOrder
    }

    hasDiscount() {
        return this.state.item.attributes.discountValue && Number(this.state.item.attributes.discountValue) != 0
    }

    getPrice() {
        let notHasDiscount = this.state.item.attributes.discountValue && Number(this.state.item.attributes.discountValue) == 0
        if (this.priceWasModified() && notHasDiscount) {
            return this.state.calculatedPrice
        }
        return this.state.unitPrice
    }

    render() {
        if (!this.state.item || !this.state.item.attributes) {
            return ''
        }
        let price = ""
        if(!this.state.stockDocumentDirection){
            price = <LabelAmountPerUnitOfMeasure
            shortFormat={this.props.shortFormat}
            value={this.state.item.attributes.calculatedUnitPrice}
            currency={this.state.item.attributes.currency}
            unit={this.state.item.attributes.unitOfMeasure}
        />
        }else{
            price = <LabelAmountPerUnitOfMeasure
            shortFormat={this.props.shortFormat}
            value={this.state.item.attributes.unitCost}
            currency={this.state.item.attributes.currency}
            unit={this.state.item.attributes.unitOfMeasure}
            />
        }

        if (this.state.editMode || this.props.hideEditButtons) {
            price = <div>
                <p className="m-0">
                    <ItemPriceWrapperWarning
                        item={this.props.item}
                        unitPrice={this.getPrice()}
                        isPricingTable={ AppContext.getAccount().attributes.showPriceWarning && !this.state.isBeingEdited
                            && !this.state.stockDocument }
                        onChange={(value) => this.changePrice(value)}
                    >
                        {(hasNewPriceValue) => (
                            <MoneyInputForm
                                hasNewPriceValue={hasNewPriceValue}
                                className={'form-control-sm'}
                                disabled={
                                    (!this.state.stockDocument && ((this.priceWasModified() && !this.hasDiscount() && Number(this.getPrice()) != 0) 
                                    || (this.props.syncItemsWithCatalogPrices))) || !this.state.editable
                                }
                                groupClassName={'input-group-sm'}
                                currency={this.state.item.attributes.currency}
                                value={this.getPrice()}
                                onChange={(newValue) => {
                                    this.changePrice(newValue, true)
                                }}
                                onBlur={() => {
                                    this.changePrice(this.getPrice(), false)
                                }}
                                debounced={true}
                                debounceTimeout={1000}
                            />)}
                    </ItemPriceWrapperWarning>
                </p>

                {!this.props.hideEditButtons && <p className="m-0 pt-2">
                    <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                        <Icon value={"arrow-left"} />
                    </button>
                    <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                        <Icon value={"save"} />
                    </button>
                </p>}

            </div>
        }
        return price
    }

}

const mapState = (state, props) => {
    const id = props.itemId
    const objectId = props.mainObjectId
    const item = getPricingTableItem(state, id, objectId)
    return {
        ...props,
        item: item,
        pricingTableId: getPricingTableId(state, objectId)
    }
}
export default connect(mapState)(injectIntl(QuoteItemUnitPrice))





// WEBPACK FOOTER //
// ./src/common/quote/itemunitprice.component.jsx